<template>
  <div>
    <div class="shadow rounded-4 overflow-hidden" style="width: 90%; max-width: 500px; margin-top: 35vh; margin-bottom: 10vh; margin-left: 2vw;">
      <div class="card-header d-flex align-items-center justify-content-center bg-goethe-accent" style="height: 25px">
        <!-- <div class="row">
          <div class="col-12 text-center">
            <h2 class="text-white">Goethe ID</h2>
          </div>
        </div> -->
      </div>
      <div class="card-body p-2 fondo-terciario">
        <div class="d-flex flex-column align-items-center m-0 p-1 gap-2" v-if="message!=''" role="alert">
          <p class="m-0">{{ message }}</p>
          <router-link v-if="redirect" class="btn bg-goethe-accent texto-principal" :to='redirect' style="height: 100%;">{{$t('volver')}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';

export default {
  name: 'MessageBox',
  setup() {
    const message = ref('');
    
    const storedMessage = localStorage.getItem('message');
    const redirect = localStorage.getItem('redirect');
    message.value = storedMessage !== null ? storedMessage : '';

    return {
      message,
      redirect
    };
  }
};
</script>

<style scoped>
.invalid-feedback {
  display: block;
}
</style>
